import axios from 'axios';
import promise from 'promise';

import CookiesWrapper from '../common/cookies-wrapper';
import constants from '../common/constants';

export default function initilizeHttpClient() {
  const baseURL = constants.api_url;
  const instance = axios.create();
  instance.defaults.headers.common = {};
  axios.defaults.baseURL = baseURL;

  function blockPageScroll() {
    if (document.body.className.indexOf('loader-block-scroll') === -1) {
      document.body.className += ' loader-block-scroll';
    }
  }

  function unblockPageScroll() {
    document.body.className = document.body.className.split('loader-block-scroll').join('');
  }

  axios.interceptors.request.use(
    config => {
      const tokens = CookiesWrapper.getCookie(constants.cookie_key_word);

      blockPageScroll();

      // if request url is towards V2 send appropriate headers
      if (config.url.indexOf(baseURL) > -1 && config.method !== 'OPTIONS' && tokens) {
        if (tokens) {
          config.headers['x-token'] = tokens.token;
          config.headers['x-xsrf-token'] = tokens.xsrf;
        }
      }

      return config;
    },
    error => {
      unblockPageScroll();
      return promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    response => {
      unblockPageScroll();
      return response;
    },
    error => {
      unblockPageScroll();

      return Promise.reject(error);
    }
  );
}



// WEBPACK FOOTER //
// ./src/core/axios-config.js